module.exports = "/virtual-football-league/img/amblems/left/logos/CrystalPalace.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/CrystalPalace.png
// module id = 2064
// module chunks = 4